import { useEffect, useState } from 'react';
import { getMarke } from '../api/client';

/**
 * Der Name der Firma, die diese Installation betreibt — für die Menüspalte und
 * die Anmeldeseite (`PF-marke`, Spec Systemeinstellungen Abschnitt 7, `D-16`,
 * Fall `E-1657`).
 *
 * **Welcher Name, entscheidet der Server** (`PF-lizenzname`, `D-50`,
 * `E-1731`): zuerst der Kundenname des hinterlegten, signaturgeprüften
 * Lizenzschlüssels — auch vor dem Abschluss der Einrichtung und gleichgültig,
 * ob die Lizenz gerade gültig ist —, sonst der Name der geltenden
 * Ausstellerfassung. Die Oberfläche unterscheidet beides nicht; die Antwort
 * sagt es auch nicht. Bis zu 200 Zeichen: Wer ihn zeigt, kürzt mit Auslassung
 * und legt den vollen Namen in den `title`.
 *
 * **Der Firmenname kommt vom Server und steht in keinem gebauten Bündel.**
 * Bis zu diesem Auftrag trugen `Sidebar.tsx` und `LoginPage.tsx` den Namen des
 * Herstellers als Zeichenkette; eine fremde Firma hätte ihn am ersten Tag auf
 * ihrer eigenen Anmeldeseite gesehen. Jetzt fragt die Oberfläche
 * `GET /api/v1/einstellungen/marke` (ohne Sitzung erreichbar, gibt nur Namen
 * und Einrichtungsstand preis).
 *
 * **`null` heisst: nur den Produktnamen zeigen.** Das gilt, solange die
 * Einrichtung offen ist und keine Lizenz hinterlegt (der Server sendet dann
 * `null`), wenn ohne Lizenz für heute keine Ausstellerfassung gilt, solange
 * die Antwort unterwegs ist **und wenn sie fehlschlägt**. Eine Anmeldeseite, die wegen eines fehlgeschlagenen
 * Namensabrufs nicht erscheint, wäre schlimmer als eine ohne Firmenname — der
 * Abruf ist Zierde, nicht Voraussetzung der Anmeldung.
 */

/** Der Name der Lizenz bzw. der geltenden Ausstellerfassung, sonst `null`. */
export function useFirmenname(): string | null {
  const [name, setName] = useState<string | null>(null);

  useEffect(() => {
    let verworfen = false;
    void (async () => {
      try {
        const marke = await getMarke();
        if (!verworfen) setName(marke.firmenname);
      } catch {
        // Bewusst geschluckt: siehe Kopfkommentar — ohne Namen bleibt es beim
        // Produktnamen, und die Anmeldung selbst hängt daran nicht.
        if (!verworfen) setName(null);
      }
    })();
    return () => {
      verworfen = true;
    };
  }, []);

  return name;
}
